import React, { useEffect } from "react";
import { APPLICATION_NAME, RODEO_PAGE_NAME } from "src/_config";
import Sidebar from "src/components/common/Sidebar";
import CmsPage from "src/components/cms/cmsPage";

export default function CmsContainer() {
  return (
    <React.Fragment>
      <section className="main-container">
        <Sidebar page={RODEO_PAGE_NAME.CMS} />
        <CmsPage />
      </section>
    </React.Fragment>
  );
}
